import { render, staticRenderFns } from "./RoleDrawerKnowledgeBaseTab.vue?vue&type=template&id=1fdd197e&scoped=true&"
import script from "./RoleDrawerKnowledgeBaseTab.vue?vue&type=script&lang=js&"
export * from "./RoleDrawerKnowledgeBaseTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdd197e",
  null
  
)

export default component.exports